import { toast } from 'react-hot-toast'

let isServerErrorToastShown = false
let isForbiddenErrorToastShown = false

export const handleError = (error: any) => {
    const status = error.response?.status

    if (status === 500 && !isServerErrorToastShown) {
        isServerErrorToastShown = true
        toast.error('Szerverhiba történt. Kérlek próbáld újra később.', {
            duration: 5000,
            iconTheme: {
                primary: '#e53935',
                secondary: '#fff',
            },
            style: {
                background: '#1c1c1c',
                color: '#fff',
            },
        })
    } else if (status === 403 && !isForbiddenErrorToastShown) {
        isForbiddenErrorToastShown = true
        toast.error('Nincs jogosultságod ehhez a művelethez.', {
            duration: 5000,
            iconTheme: {
                primary: '#e53935',
                secondary: '#fff',
            },
            style: {
                background: '#1c1c1c',
                color: '#fff',
            },
        })
    }

    return Promise.reject(error)
}

export const attachToken = (tokenGetter: () => string | null) => (config: any) => {
    const token = tokenGetter()
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
}
